import type { CSSProperties } from 'react';

import { isDefined } from '@enterprise/core';

import type { LoadingProps } from './types/loading.props';

/**
 * Renders a dual ring loading spinner.
 *
 * @internal
 *
 * @param size - The multiplier for the spinner size. If greater than 1, applies a corresponding CSS class.
 * @returns A div element with appropriate loader classes for displaying a dual ring spinner.
 */
export const DualRing = ({ size }: LoadingProps) => {
  return (
    <div
      className="loader-dual-ring"
      data-testid="loader-dual-ring"
      style={{ '--multiplier': isDefined(size) ? size : undefined } as CSSProperties}
    />
  );
};
